import { lazy } from 'react';
import { RemoteModule } from '../components/remote-module/remote-module';
import { useMessage } from '../i18n/useMessage';
import { UnicornApi } from '@cld/unicorn-api';

const RemoteOptimizationCenter = lazy(() =>
  import('@cld-remote/optimization_center/index').then(({ OptimizationCenter: OptimizationCenterPage }) => ({
    default: OptimizationCenterPage,
  }))
);

export const OptimizationCenter = ({ unicornApi }: { unicornApi: UnicornApi }) => {
  const { productEnvironment } = unicornApi.data;
  const t = useMessage();

  const navigateToSettings = () => window.location.assign(`${window.location.origin}/settings/c-${productEnvironment.externalId}/optimization`);

  return (
    <RemoteModule documentTitle={t('optimization-center')}>
      <RemoteOptimizationCenter onGoToSettings={navigateToSettings} />
    </RemoteModule>
  );
};
